import { NavContext } from '@ionic/react';
import { MobilePageDetail, useParams } from '@tbitop/mobile-app';
import { useRouting } from '@tbitop/routing';
import { Accordion, AccordionItem, Header1, Header2, Modal } from '@tbitop/ui';
import { isEmpty, isNull, partition } from 'lodash-es';
import { useContext } from 'react';
import { useObjekt } from '../infrastructure/graphql';
import { Aufgabe, AufgabenList, Objektdaten } from '../ui/controller';

const offeneAufgabenHeader = 'Offene Aufgaben';

export const Objekt = () => {
  const navigation = useContext(NavContext);
  const { query } = useRouting();
  const { objektId } = useParams();

  const openedAufgabenId = query.aufgabenId;

  const { loading, objekt } = useObjekt(objektId as string);

  const [offeneAufgaben, erledigteAufgaben] = partition(objekt?.aufgaben, aufgabe => aufgabe.status === 'Offen');
  const aufgabenDetailsOpen = !isNull(openedAufgabenId) && !isEmpty(openedAufgabenId);

  const closeModal = () => navigation.goBack();

  return (
    <MobilePageDetail title={loading ? 'Objekt wird geladen' : 'Objektansicht'} loading={loading}>
      <div className="ml-300">
        <Header1 className="text-tds-color-copy-on-light-10">{objekt?.name}</Header1>
        <Header2 className="text-tds-color-copy-on-light-10">{objekt?.name2}</Header2>
      </div>
      <Accordion className="mt-300" openItems={offeneAufgaben.length > 0 ? [offeneAufgabenHeader] : undefined}>
        <AccordionItem header="Details">
          <Objektdaten objekt={objekt} />
        </AccordionItem>
        <AccordionItem header={offeneAufgabenHeader} disabled={offeneAufgaben.length === 0}>
          <AufgabenList aufgaben={offeneAufgaben} showAbschliessenButtons />
        </AccordionItem>
        <AccordionItem header="Erledigte Aufgaben" disabled={erledigteAufgaben.length === 0}>
          <AufgabenList aufgaben={erledigteAufgaben} />
        </AccordionItem>
      </Accordion>
      <Modal isOpen={aufgabenDetailsOpen} onClose={closeModal} size="large">
        {aufgabenDetailsOpen ? <Aufgabe aufgabenId={openedAufgabenId} onClose={closeModal}/> : null}
      </Modal>
    </MobilePageDetail>
  );
};
